// extracted by mini-css-extract-plugin
export var cardLayout = "_27-1";
export var paginationContainer = "_27-0";